import { Box, makeStyles } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import { atom } from 'recoil';
import { BookingError } from './BookingError';
import { ExistingAccount } from './Existing';
import { PinCode } from './Pincode';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      height: '100%'
    }
  }
})

const loginBookingState = atom({
  key: 'loginBookingData',
  default: {}
})


const Login = ({ }) => {
  const classes = useStyles()
  return (
    <Box
      className={classes.root}

      spacing={0}
      align="center"
      justify="center"
      direction="column"
    >

      <Switch>
        <Route exact path="/bookings/login/:serviceId/existing" component={ExistingAccount} />
        <Route exact path="/bookings/login/:serviceId/error" component={BookingError} />
        <Route path="/bookings/login/:serviceId" component={PinCode} />
      </Switch>

    </Box>
  )
}

export {
  Login, loginBookingState
};
